import { render, staticRenderFns } from "./LandTitleLayout.vue?vue&type=template&id=a213f728&scoped=true&"
import script from "./LandTitleLayout.vue?vue&type=script&lang=js&"
export * from "./LandTitleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a213f728",
  null
  
)

export default component.exports